import { make } from 'vuex-pathify'
import actions from './actions'
import gettersCustom from './getters'

const inistialState = () => ({
  shippingMethods: null,
  loadingShipping: false
})

const state = inistialState()

const getters = {
  ...gettersCustom,
  ...make.getters(state)
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
